import React from 'react';

import { Col, Cols, Div, spacing } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

export interface IMobileFilterSelection {
  label: string;
  value: number; // start with 1; 0 represents none
  SVGIcon: any;
}

interface IFilterSelectorProps {
  activeOption: number;
  options: IMobileFilterSelection[];
  handleClick: React.Dispatch<React.SetStateAction<number>>;
}

export const FilterSelector = ({
  activeOption = 0,
  options,
  handleClick,
}: IFilterSelectorProps) => {
  return (
    <Cols gap={spacing.extraSmall} style={{ alignItems: 'center' }}>
      {options.map((option) => {
        const isActive = option.value === activeOption;
        return (
          <Col>
            <Div
              displayFlex
              style={{
                padding: '8px',
                borderRadius: '4px',
                backgroundColor: isActive ? publicaColors.lightGray : 'inherit',
              }}
              onClick={() => handleClick(isActive ? 0 : option.value)}
            >
              <option.SVGIcon color={isActive ? publicaColors.black : publicaColors.darkGray} />
            </Div>
          </Col>
        );
      })}
    </Cols>
  );
};
